import { Divider, Grid, styled } from '@mui/material';
import { useState } from 'react';
import { EmailLog, IEmailLogGroup, IPaginationAPIResponse } from 'wisestep-api';
import { getDateUsingFormat, WsColors } from 'wisestep-base';

import { useWorkspaceContext } from '../../../../../context';
import { useGetEmailSettingForJob } from '../../../../../features/automatedEmailCampaignSettings';
import { EmailBody, EmailSubject } from '../../emailContent';
import { EmailHeaderBanner } from '../../emailHeaderBanner';
import { EmailPreviewCard } from '../../emailPreviewCard';

export const Sidebar = styled(Grid)(() => ({
  height: 600,
  overflowY: 'auto',
  overflowX: 'hidden',
  borderRight: `1px solid ${WsColors.BorderDivider}`,
}));

export const EmailContentWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(2),
  padding: theme.spacing(2),
}));

export const EmailBodyContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(2),
  width: '100%',
}));

export const EmailLayoutGrid = styled(Grid)(() => ({
  display: 'flex',
  width: '100%',
}));

export const EmailLayout = ({
  emailList,
  jobId,
}: {
  emailList: IPaginationAPIResponse<IEmailLogGroup>;
  jobId: string;
}) => {
  const [selectedItem, setSelectedItem] = useState<number>(0);
  const { emailCampaignSettingForJob } = useGetEmailSettingForJob(jobId);
  const user = useWorkspaceContext();

  return (
    <EmailLayoutGrid>
      <Sidebar xs={3} display="flex" direction="column" rowGap={1}>
        {emailList?.content?.map((email, index) => (
          <Grid
            item
            width="100%"
            key={index}
            onClick={() => setSelectedItem(index)}
            sx={{
              bgcolor: selectedItem === index ? WsColors.BackGroundBrandLight : '',
            }}
          >
            <EmailPreviewCard
              userName={`To: ${
                email?.messages?.[0]?.candidateName ??
                email?.messages?.[0]?.to?.[0] ??
                `Not Available`
              }`}
              subject={email?.messages?.[0]?.subject ?? 'Not Available'}
              emailSentTime={
                email?.messages?.[0]?.createdOn
                  ? getDateUsingFormat(email.messages?.[0].createdOn.toString(), 'DD MMM')
                  : ''
              }
              bodyPreview={email?.messages?.[0]?.body ?? 'Not Available'}
            />
            <Divider />
          </Grid>
        ))}
      </Sidebar>

      <EmailContentWrapper key={selectedItem} xs={9}>
        <EmailHeaderBanner
          emailLog={emailList?.content?.[selectedItem]?.messages?.[0] ?? ({} as EmailLog)}
        />

        <Grid px={2} container display="flex" rowGap={2}>
          <EmailSubject
            emailsubject={
              emailList?.content?.[selectedItem]?.messages?.[0]?.subject ?? 'Not Available'
            }
          />
          {emailList?.content?.[selectedItem]?.messages.map((emailLog, index) => {
            const messages = emailList?.content?.[selectedItem]?.messages ?? [];
            const isLastMessage = index === messages.length - 1;

            return (
              <EmailBodyContainer item key={index}>
                <EmailBody
                  emailLog={emailLog ?? ({} as EmailLog)}
                  defaultExpand={isLastMessage}
                  showReply={isLastMessage}
                  recruiterAccess={emailCampaignSettingForJob?.manualReplyFrom === user?.userId}
                />
                {!isLastMessage && <Divider />}
              </EmailBodyContainer>
            );
          })}
        </Grid>
      </EmailContentWrapper>
    </EmailLayoutGrid>
  );
};
